import { Link } from 'react-router-dom'
import { getImageUrl } from '../../utils/imageUrl'
import { productPath } from '../../utils/productUrl'
import { formatDateShort, formatDateLong } from '../../utils/formatDate'

/** Ensartet nyhedskort på forsiden og /nyheder */
export function NyhedCard({ item, dateFormat = 'short' }) {
  const formatDate = dateFormat === 'long' ? formatDateLong : formatDateShort

  if (item.type === 'review') {
    const to = item.product_id ? `/products/${item.product_id}` : '#'
    return (
      <Link to={to} className="nyhed-kort nyhed-anmeldelse">
        <span className="nyhed-badge nyhed-badge--review">Ny anmeldelse</span>
        <div className="nyhed-tekst">
          {item.product_name && <strong>{item.product_name}</strong>}
          {item.summary && (
            <p>
              {item.summary.length > 120 ? `${item.summary.substring(0, 120)}…` : item.summary}
            </p>
          )}
          {item.rating != null && <span className="nyhed-rating">⭐ {item.rating}/10</span>}
          <span className="nyhed-dato">{formatDate(item.created_at)}</span>
        </div>
      </Link>
    )
  }

  const product = item.product || item
  const badgeClass =
    item.type === 'updated' ? 'nyhed-badge--update' : ''
  const badgeLabel = item.type === 'updated' ? 'Opdateret' : 'Nyt produkt'
  const date = item.type === 'updated' ? product.updated_at : product.created_at

  return (
    <Link
      to={product.url_path || productPath(product)}
      className={`nyhed-kort nyhed-produkt${item.type === 'updated' ? ' nyhed-opdateret' : ''}`}
    >
      <span className={`nyhed-badge ${badgeClass}`.trim()}>{badgeLabel}</span>
      <div className="nyhed-billede">
        {product.primary_image_url ? (
          <img src={getImageUrl(product.primary_image_url)} alt={product.name} />
        ) : (
          <div className="nyhed-placeholder" />
        )}
      </div>
      <div className="nyhed-tekst">
        <strong>
          {product.brand} {product.model}
        </strong>
        {product.year && <span className="nyhed-year">{product.year}</span>}
        <span className="nyhed-dato">{formatDate(date)}</span>
      </div>
    </Link>
  )
}
